import request from '@/utils/requestCenter'


const reqPrefix = '/youngbook/lsMallUser/fuelApi/fuel/apply/'

//预监督核销(Id查询申请详情)
export function preWatchWriteOff(applyId) {
    return request({
        method: 'get',
        url: `${reqPrefix}preWatchWriteOff/${applyId}`
    })
}
//查询全部的加注站列表
export function allStation() {
    return request({
        method: 'get',
        url: `${reqPrefix}allStation`
    })
}
//根据加注站Id查询其下的加注枪列表
export function allGun(stationId) {
    return request({
        method: 'get',
        url: `${reqPrefix}allGun/${stationId}`
    })
}
//司机监督核销
export function watchWriteOff(data) {
    return request({
        method: 'post',
        url: `${reqPrefix}watchWriteOff`,
        data: data
    })
}
// 查询二维码是否已经被管理员确认
export function verifyConfirm(applyId) {
    return request({
        method: 'get',
        url: `${reqPrefix}verifyConfirm/${applyId}`
    })
}